module.exports = __webpack_public_path__ + "img/kapplopning.6929c222.jpg";